export const apps = [
  {
    id: 1,
    name: 'arbiterTeam',
    icon: 'referee',
    route: 'arbitration-team',
  },
  {
    id: 2,
    name: 'kitSelector',
    icon: 'kitSelector',
    route: 'kit-selector',
  },
  {
    id: 3,
    name: 'grassStatus',
    icon: 'grassStatus',
    route: 'grass-status',
  },
  {
    id: 4,
    name: 'matchSheet',
    icon: 'matchSheet',
    route: 'match-sheet',
  },
  {
    id: 5,
    name: 'protocolActs',
    altLoggedname: 'commercials',
    icon: 'acts',
    route: 'protocol-commercial-acts',
  },
];
